export const approvalKeys = {
  all: ["approvals"] as const,
  inbox: (bookkeepingYearId: string | undefined) =>
    ["approvals", "inbox", bookkeepingYearId] as const,
  rules: (organizationId: string | undefined) =>
    ["approvals", "rules", organizationId] as const,
  decisions: (transactionId: string | undefined) =>
    ["approvals", "decisions", transactionId] as const,
  pendingCount: (bookkeepingYearId: string | undefined) =>
    ["approvals", "pendingCount", bookkeepingYearId] as const,
  orgYears: (bookkeepingId: string) =>
    ["approvals", "orgYears", bookkeepingId] as const,
};
